import {INPUT_REG_EXP, VALID_CODE} from "./constant.js"
import {InputErrorHandler} from "../input-error-handler/index.js";

function getInputErrorJson($inputObjects, type) {
    const emptyInput = getEmptyInput($inputObjects);
    const isEmpty = emptyInput.length > 0;
    const isTempType = type === 'temporary';
    if (isEmpty) {
        const errorMsg = isTempType ? i18next.t(main.alert.noTemporaryContents) : emptyInput.attr('data-' + VALID_CODE.EMPTY + '-msg');
        return makeErrorJson(emptyInput, VALID_CODE.EMPTY, errorMsg);
    }

    const overInput = getOverInput($inputObjects);
    const isOver = overInput.length > 0;
    if (isOver) {
        const errorMsg = isTempType ? i18next.t(main.alert.noTemporaryContents) : overInput.attr('data-' + VALID_CODE.OVER + '-msg');
        return makeErrorJson(overInput, VALID_CODE.OVER, errorMsg);
    }


    const invalidInput = getInvalidInput($inputObjects);
    const isInvalid = invalidInput.length > 0;
    if (isInvalid) {
        const errorMsg = isTempType ? i18next.t(main.alert.noTemporaryContents) : invalidInput.attr('data-' + VALID_CODE.INVALID + '-msg');
        return makeErrorJson(invalidInput, VALID_CODE.INVALID, errorMsg);
    }

    const invalidLetterCaseInput = getInvalidLetterCaseInput($inputObjects);
    const invalidLetterCase = invalidLetterCaseInput.length > 0;
    if (invalidLetterCase) {
        const errorMsg = isTempType ? i18next.t(main.alert.noTemporaryContents) : invalidLetterCaseInput.attr('data-' + VALID_CODE.INVALID_LETTER_CASE + '-msg');
        return makeErrorJson(invalidLetterCaseInput, VALID_CODE.INVALID_LETTER_CASE, errorMsg);
    }

    return {};
}

function getInputValue(inputEl) {
    return $.trim($(inputEl).val());
}

function getEmptyInput($inputObjects) {
    let $emptyInput = $("");
    $.each($inputObjects, function (i, inputEl) {
        const value = getInputValue(inputEl);
        const isRequired = "Y" === Mutil.n2v($(inputEl).attr('data-required-yn'), 'N');
        if (Mutil.empty(value) && isRequired) {
            $emptyInput = $(inputEl);
            return false;
        }
    })
    return $emptyInput;
}

function getOverInput($inputObjects) {
    let $overInput = $("");
    $.each($inputObjects, function (i, inputEl) {
        const value = getInputValue(inputEl);
        const maxLength = Number(Often.null2Void($(inputEl).attr('maxlength'), '50'));
        const isOver = maxLength < value.length;
        if (isOver) {
            $overInput = $(inputEl);
            return false;
        }
    })
    return $overInput;
}
function getUnderInput($inputObjects) {
    let $underInput = $("");
    $.each($inputObjects, function (i, inputEl) {
        const value = getInputValue(inputEl);
        const minLength = Number(Often.null2Void($(inputEl).attr('minlength'), '0'));
        const isUnder = minLength > value.length;
        if (isUnder) {
            $underInput = $(inputEl);
            return false;
        }
    })
    return $underInput;
}

function getInvalidInput($inputObjects) {
    let $invalidInput = $("");
    $.each($inputObjects, function (i, inputEl) {
        const value = getInputValue(inputEl);
        const validCode = Often.null2Void($(inputEl).attr('data-valid'), '')
        const isUnValid = isUnValidValue(validCode, value, inputEl);
        if (isUnValid) {
            $invalidInput = $(inputEl);
            return false;
        }
    })
    return $invalidInput;
}
function getInvalidLetterCaseInput($inputObjects) {
    let $invalidLetterCaseInput = $("");
    $.each($inputObjects, function (i, inputEl) {
        const value = getInputValue(inputEl);
        const isOnlyLowerCase= "N" === Mutil.n2v($(inputEl).attr('data-uppercase-yn'), 'Y');
        const isContainUpperCase = checkContainUpperCase(value);
        if (isOnlyLowerCase && isContainUpperCase) {
            $invalidLetterCaseInput = $(inputEl);
            return false;
        }
    })
    return $invalidLetterCaseInput;
}

function makeErrorJson(targetObj, errorCode, errorMsg) {
    return {
        errorObj: targetObj,
        errorCode: errorCode,
        errorMessage: errorMsg,
    };
}
function isValidInput($inputObjects, type="") {
    return Object.values(getInputErrorJson($inputObjects, type)).length === 0
}

function inputValidate($inputObject) {
    if ($inputObject.length === 0) {
        Mutil.mlog("입력 태그가 존재하지 않아 타당성 검사를 할 수 없습니다.");
        return false;
    }

    InputErrorHandler.validHandler($inputObject);
    const isValid = isValidInput($inputObject);
    Mutil.mlog(` 입력(${$inputObject.attr("data-valid")}) 태그 타당성 검사 ${isValid ? "성공!" : "실패!"} >> ${$($inputObject).val()}`);
    return isValid;
}
function inputsValidate($inputsObject) {
    if ($inputsObject.length === 0) {
        Mutil.mlog("입력 태그들이 존재하지 않아 타당성 검사를 할 수 없습니다.");
        return;
    }

    const invalidInputs = Array.from($inputsObject)
        .filter((input) => !inputValidate($(input)));
    return invalidInputs.length === 0;
}
function check($inputObjects, isToast, type) {
    const errorJson = getInputErrorJson($inputObjects, type);
    const isError = Object.values(errorJson).length > 0;
    if (!isError) {
        return {};
    }
    if (isToast) {
        Often.toast("error", errorJson.errorMessage)
        errorJson.errorObj.focus();
    }

    return errorJson;
}

function isUnValidValue(validCode, value, inputEl) {
    const isValidPassword = new RegExp(getPasswordRex()).test(value);
    const isValidLoginPassword = new RegExp(INPUT_REG_EXP.LOGIN_PASSWORD).test(value);
    const isEmoji = new RegExp(INPUT_REG_EXP.EMOJI).test(value);
    const isNameSpecial = new RegExp(INPUT_REG_EXP.NAME_SPECIAL).test(value);
    const isValidName = !isNameSpecial && !isEmoji;
    const isValidDomain = new RegExp(INPUT_REG_EXP.DOMAIN).test(value);
    const validInputCheck = new RegExp(/^[\+?(\d*|\-(?!\-))*]{1,20}$/g).test(value);
    const continuousSign = new RegExp(/[-+]{2,}/g).test(value);
    const isNumberExist = new RegExp(/\d/).test(value);
    const isPlusFirst = new RegExp(/^([^+]*\+)?[^+]*$/).test(value);
    const isMinusMiddle = !new RegExp(/^-|-$/).test(value);
    const isValidPhoneNumber = validInputCheck && !continuousSign && isNumberExist && isPlusFirst && isMinusMiddle;

    const isValidNumber = new RegExp(INPUT_REG_EXP.NUMBER).test(value);

    return (
        ("teamUrl" === validCode && !isValidTeamUrl(value)) ||
        ("name" === validCode && !isValidName) ||
        ("email" === validCode && !isValidEmail(value)) ||
        ("password" === validCode && !isValidPassword) ||
        ("password-confirm" === validCode && !isSamePassword($(inputEl))) ||
        ("domain" === validCode && !isValidDomain) ||
        ("phoneNumber" === validCode && !isValidPhoneNumber) ||
        ("number" === validCode && !isValidNumber) ||
        ("login-password" === validCode && !isValidLoginPassword)
    )
}

function isSamePassword(password2Obj) {
    let $form = password2Obj.parents('form');
    return ($form.length > 0 && $form.find(".js-join-password").length > 0 &&
        password2Obj.val() === $form.find(".js-join-password").val())
}

function getPasswordRex() {
    if (Mutil.isFunc(Func.ENTER.PWD_REG_MORE_THAN_EIGHT)) return INPUT_REG_EXP.MORE_THAN_EIGHT;
    return INPUT_REG_EXP.PASSWORD;
}
function checkContainUpperCase(inputValue) {
    if(inputValue.length === 0) return false;
    return new RegExp(INPUT_REG_EXP.UPPER_CASE).test(inputValue)
}

function isValidTeamUrl(teamUrl) {
    if(teamUrl.length === 0) return false;
    return new RegExp(INPUT_REG_EXP.TEAM_URL).test(teamUrl);
}

function isValidEmail(email) {
    if(Mutil.empty(email) ||email.length === 0) return false;
    const isLowerCase = email === email.toLowerCase();
    if(!isLowerCase) {
        return false;
    }
    return  new RegExp(INPUT_REG_EXP.EMAIL).test(email) ;
}
export const InputValidator = {
    check: check,
    isValidInput:  isValidInput,
    getInputErrorJson: getInputErrorJson,
    checkContainUpperCase : checkContainUpperCase,
    isValidTeamUrl : isValidTeamUrl,
    inputValidate : inputValidate,
    inputsValidate : inputsValidate,
    isValidEmail : isValidEmail,


}